import { RefObject, useEffect } from 'react';
import { AFrameCamera, ActiveScene } from '../types';

export const useCameraSync = (
  cameraRef: RefObject<AFrameCamera | null>,
  secondCameraRef: RefObject<AFrameCamera | null>,
  isSplitView: boolean,
  activeScene: ActiveScene
): void => {
  // Sync camera rotations from active scene to inactive scene
  useEffect(() => {
    if (!isSplitView) return;

    let rafId: number | null = null;

    const syncCameras = (): void => {
      if (cameraRef.current && secondCameraRef.current) {
        const mainControls = cameraRef.current.components?.['custom-look-controls'];
        const secondControls = secondCameraRef.current.components?.['custom-look-controls'];

        if (mainControls && secondControls) {
          const currentMainYaw = mainControls.yawObject.rotation.y;
          const currentMainPitch = mainControls.pitchObject.rotation.x;
          const currentSecondYaw = secondControls.yawObject.rotation.y;
          const currentSecondPitch = secondControls.pitchObject.rotation.x;

          // Sync based on which scene is active
          if (activeScene === 'main') {
            // Sync from main to second
            secondControls.yawObject.rotation.y = currentMainYaw;
            secondControls.pitchObject.rotation.x = currentMainPitch;
          } else if (activeScene === 'second') {
            // Sync from second to main
            mainControls.yawObject.rotation.y = currentSecondYaw;
            mainControls.pitchObject.rotation.x = currentSecondPitch;
          }
        }
      }
      rafId = requestAnimationFrame(syncCameras);
    };

    rafId = requestAnimationFrame(syncCameras);

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [isSplitView, activeScene, cameraRef, secondCameraRef]);
};
